<div *ngIf="disableEditing"
    style="width: 100%; height: 100%; position: absolute; z-index: 100000; display: flex; justify-content: center; align-items: center;">
    <div class="spinner-border text-primary avatar-sm" role="status">
        <span class="visually-hidden">Loading...</span>
    </div>
</div>

<div class="modal-header bg-soft-info p-3">
    <h5 class="modal-title" id="exampleModalLabel">
        <span>Email Template</span>
    </h5>

    <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close" id="close-modal"
        (click)="close()"></button>
</div>


<div class="card-header p-4">
    <div class="col-12 d-flex gap-4 ">
        <div class="col-lg-6 mb-2">
            <div class="mb-3">
                <label class="form-label" for="project-title-input">Name</label>
                <input type="text" class="form-control" id="project-title-input" [(ngModel)]="model.name"
                    placeholder="Enter a name">
            </div>
            <div class="mb-3">
                <label class="form-label">Email Subject</label>
                <input type="text" class="form-control" id="project-title-input" [(ngModel)]="model.emailSubject"
                    placeholder="Enter a subject">
            </div>
        </div>
        <div class="col-lg-6 mb-2">
            <div class="mb-3">
                <label class="form-label">Sender Name</label>
                <input type="text" class="form-control" id="project-title-input" [(ngModel)]="model.senderName"
                    placeholder="Enter a name">
            </div>
            <div class="mb-3">
                <label class="form-label">Sender Email</label>
                <input type="text" class="form-control" id="project-title-input" [(ngModel)]="model.senderEmail"
                    placeholder="Enter a email">
            </div>
        </div>
    </div>
    <div class="col-12 d-flex gap-4">
        <div class="col-lg-6 card mb-2">
            <div class="card-header d-flex justify-content-between align-items-center">
                <h5 class="card-title mb-0">HTML Text</h5>
                <button *ngIf="textTypeIsRaw === false" type="button" class="btn btn-info" id="add-btn"
                    (click)="textTypeIsRaw = true" i18n="">Raw HTML</button>
                <button *ngIf="textTypeIsRaw === true" type="button" class="btn btn-info" id="add-btn"
                    (click)="textTypeIsRaw = false" i18n="">Rich HTML</button>
            </div>
            <div class="card-body">
                <span *ngIf="textTypeIsRaw === false">
                    <app-rich-text-editor [textToEdit]="model.content" [inputHeight]=685
                        (textToEditChange)="updateText($event)">
                    </app-rich-text-editor>
                </span>
                <span *ngIf="textTypeIsRaw === true">
                    <textarea [(ngModel)]="model.content" type="text" style="min-height: 780px;" class="form-control border-light bg-light"
                        placeholder="Enter html"></textarea>
                </span>

            </div>
        </div>
        <div class="col-lg-6 card mb-2">
            <div class="card-header d-flex justify-content-between align-items-center">
                <h5 class="card-title mb-0 d-flex align-items-center" style="height: 38px;">Email Preview</h5>
            </div>
            <div class="card-body " style="width: 743px; overflow: hidden; text-overflow: ellipsis; "
                [innerHTML]="sanitize(model.content)">
            </div>
        </div>

    </div>
</div>

<div class="card-body p-4  ">

    <div class="hstack justify-content-end gap-2" style="margin-top: 0.5rem;">
        <button *ngIf="model.id !== undefined" [disabled]="disableEditing" type="button" class="btn btn-danger" id="add-btn"
            (click)="onDelete()" i18n="">Delete</button>

        <button *ngIf="model.id == undefined" [disabled]="disableEditing" type="button" class="btn btn-success" id="add-btn"
            (click)="onCreate()" i18n="">Create</button>
        <button *ngIf="model.id !== undefined" [disabled]="disableEditing" type="button" class="btn btn-success"
            id="add-btn" (click)="onUpdate()" i18n="">Update</button>
    </div>

</div>